<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left" >
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-file-cog-outline</v-icon>{{$t('profile.strategy.qualities')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <ProfileStrategyQualityForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import ProfileStrategyQualityForm from '../../components/profilestrategyquality/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'ProfileStrategyQuality';

const { mapFields } = createHelpers({
  getterType: 'profilestrategyquality/getField',
  mutationType: 'profilestrategyquality/updateField'
});

export default {
  name: 'ProfileStrategyQualityCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    ProfileStrategyQualityForm
  },
  data() {
    return {
      item: {
        'profileStrategy' : this.$route.params.parent
      }
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('profilestrategyquality', ['create', 'reset'])
  }
};
</script>
